<template>
  <div class="yk_report">
    <div v-if="!pupopShow">
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="display: flex"
            :model="bgform"
            label-position="center"
            label-width="90px"
          >
            <el-form-item label="化学品:" style="">
              <el-input
                v-model="bgform.param.hxpMc"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="移库数量:">
              <el-input
                v-model="bgform.param.yksl"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="移库日期:">
              <el-col :span="10">
                <el-date-picker
                  v-model="bgform.param.beginTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="startTime"
                />
              </el-col>
              <el-col
                style="text-align: center"
                class="line"
                :span="3"
              >-</el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="bgform.param.endTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="endTime"
                />
              </el-col>
            </el-form-item>
            <el-form-item label="状态:" label-width="50px">
              <el-select v-model="bgform.param.zt" placeholder="请选择">
                <el-option
                  v-for="item in zhuangtaixiala"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-button
              v-preventReClick
              class="sousuoButton"
              icon="el-icon-search"
              round
              size="small"
              type="primary"
              @click="handleCurrentChange(1)"
            >搜索</el-button>
            <el-button
              v-preventReClick
              class="chongzhiButton"
              size="small"
              icon="el-icon-refresh-right"
              round
              @click="reset"
            >重置</el-button>
          </el-form>
        </div>
      </div>
      <div
        style="
          margin: auto;
          width: 95%;
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 57px;
        "
      >
        <div class="tablemes">
          <el-table
            ref="cktable"
            :data="tableData"
            border
            :cell-style="cellStyle"
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column>
              <template slot="header" slot-scope="scope">
                <el-button
                  v-preventReClick
                  type="primary"
                  class="addButton"
                  size="mini"
                  style="border: none"
                  icon="el-icon-plus"
                  @click="addPupShow(0)"
                >新增</el-button>
                <el-button
                  v-preventReClick
                  size="mini"
                  icon="el-icon-plus"
                  @click="copyAdd"
                >复制新增</el-button>
                <el-button
                  v-preventReClick
                  icon="el-icon-upload2"
                  size="mini"
                  @click="exportlb"
                >导出</el-button>
              </template>
              <el-table-column
                align="center"
                type="selection"
                width="55"
              />

              <el-table-column
                v-for="(item, i) in table"
                :key="i"
                :show-overflow-tooltip="true"
                align="center"
                :label="item.label"
                :width="item.key == 'ykbh' ? '180' : ''"
              >
                <template slot-scope="scope">
                  <span
                    v-if="item.label !== '移库数量'"
                    :title="scope.row[item.key]"
                  >
                    {{ scope.row[item.key] }}
                  </span>
                  <span v-else>
                    {{ scope.row.yksl }} {{ scope.row.ykslDwMc }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="bgcs" label="变更次数">
                <template slot-scope="scope">
                  <span
                    v-preventReClick
                    style="cursor: pointer"
                    @click="bgcsClick(scope.row)"
                  >{{ scope.row.bgcs }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :show-overflow-tooltip="true"
                prop="zt"
                label="状态"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.zt == '00'" style="color: #333">{{
                    scope.row.ztMc
                  }}</span>
                  <span v-if="scope.row.zt == '01'" style="color: #43a5e2">{{
                    scope.row.ztMc
                  }}</span>
                  <span v-if="scope.row.zt == '11'" style="color: #43a5e2">{{
                    scope.row.ztMc
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="200px">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.zt != '00'"
                    v-preventReClick
                    type="primary"
                    icon="el-icon-document"
                    size="mini"
                    @click="addPupShow(2, scope.row.id, scope.row)"
                  >查看</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="addPupShow(3, scope.row.id)"
                  >编辑</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    type="primary"
                    class="deleteButton"
                    icon="el-icon-delete"
                    size="mini"
                    @click="hshanchu(scope.row.id)"
                  >删除</el-button>
                  <el-button
                    v-if="scope.row.zt != '00'"
                    v-preventReClick
                    :type="scope.row.zt == '11' ? 'info' : 'warning'"
                    :disabled="scope.row.zt == '11'"
                    icon="el-icon-edit"
                    size="mini"
                    @click="addPupShow(4, scope.row.id, scope.row)"
                  >变更</el-button>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev,pager,next,jumper,total,sizes"
            :total="total"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="bgform.size"
            :current-page.sync="currentPage"
            @size-change="pagesizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <bgcs
      :bgwindow="bgwindow"
      bgcs-t-k-name="移库报备"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <yk-report-pup
      v-if="pupopShow"
      ref="ykReportPup"
      :children-type="childrenType"
      :ckdisable="ckdisable"
      :djrqshow="djrqshow"
      :bgdisable="bgdisable"
    />
  </div>
</template>
<script>
import {
  APIykbbzhuangtai, // 状态下拉
  APIysbbliebiaoall, // 获取列表
  APIshanchuykbb, // 删除
  APIykbbdaochu // 导出
} from '@/assets/js/wangshuai.js'
import YkReportPup from './ykReportPup.vue'
import bgcs from '@/components/bgcs'
export default {
  components: { YkReportPup, bgcs },
  props: {},
  data() {
    return {
      zhuangtaixiala: [], // 状态下拉

      startTime: {
        disabledDate: (time) => {
          if (this.bgform.param.endTime) {
            return (
              time.getTime() > new Date(this.bgform.param.endTime).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.bgform.param.beginTime) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.bgform.param.beginTime).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },

      // 搜素表格
      bgform: {
        page: 1,
        size: 10,
        param: {
          hxpMc: '',
          yszBh: '',
          beginTime: '',
          endTime: '',
          yksl: '',
          zt: ''
        }
      },
      bgwindow: false,
      checkedTableList: '',
      pupopShow: false,
      // 登记日期是否显示
      djrqshow: false,
      // 查看状态是否显示
      ckdisable: false,
      // 变更是否显示
      bgdisable: false,
      searchForm: {},
      table: [
        {
          key: 'ykbh',
          label: '移库编号'
        },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },
        {
          key: 'ycqCkmc',
          label: '移出仓库'
        },
        {
          key: 'ychCkmc',
          label: '移入仓库'
        },

        {
          key: 'yksl',
          label: '移库数量'
        },
        {
          key: 'ykrq',
          label: '移库日期'
        }
      ],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1 // 当前页
    }
  },
  mounted() {
    // 搜索下拉状态
    APIykbbzhuangtai().then((res) => {
      this.zhuangtaixiala = res.data.data
    })
    this.htableDataall()
  },
  created() {},

  beforeDestroy() {},
  methods: {
    bgcsClick(curRow) {
      this.curRowObj = curRow
      this.$bus.emit('bgcsOpen', curRow, 'ykbb')
      this.bgwindow =
        curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    },
    // 导出
    exportlb() {
      APIykbbdaochu(this.bgform).then((res) => {
        const table = '移库报备'
        const a = document.createElement('a')
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 删除
    hshanchu(id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        APIshanchuykbb(id).then((res) => {
          this.htableDataall()
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
      })
    },
    // 点击重置时
    reset() {
      this.currentPage = 1
      this.bgform.page = 1
      this.bgform.size = 10
      this.bgform.param.hxpMc = ''
      this.bgform.param.yszBh = ''
      this.bgform.param.beginTime = ''
      this.bgform.param.endTime = ''
      this.bgform.param.zt = ''
      this.bgform.param.yksl = ''
      this.htableDataall()
    },
    // 获取全部数据
    htableDataall() {
      APIysbbliebiaoall(this.bgform).then((res) => {
        this.tableData = res.data.data.rows
        this.total = res.data.data.total
      })
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    addPupShow(type, id, row) {
      this.pupopShow = true
      if (type == 0) {
        // 新增
        this.djrqshow = false
        this.ckdisable = false
        this.bgdisable = false
        this.childrenType = '新增'
      } else if (type == 2) {
        // 查看
        this.djrqshow = true
        this.ckdisable = true
        this.bgdisable = false
        this.childrenType = '查看'

        setTimeout(() => {
          this.$bus.emit('fatherToChil', row, 'ykbb')
          this.$refs.ykReportPup.hhuoquxiangqing(id)
        }, 30)
      } else if (type == 3) {
        // 编辑
        this.djrqshow = true
        this.ckdisable = false
        this.bgdisable = false
        this.childrenType = '编辑'

        setTimeout(() => {
          this.$refs.ykReportPup.hhuoquxiangqing(id)
        }, 30)
      } else if (type == 4) {
        // 变更
        this.djrqshow = true
        this.ckdisable = false
        this.bgdisable = true
        this.childrenType = '变更'
        setTimeout(() => {
          this.$bus.emit('fatherToChil', row, 'ykbb')
          this.$refs.ykReportPup.hhuoquxiangqing(id)
        }, 30)
      }
    },
    copyAdd() {
      if (this.checkedTableList == '') {
        this.$message.warning('请先选中一条数据!')
        return
      } else {
        setTimeout(() => {
          this.$refs.ykReportPup.hhuoquxiangqing(this.checkedTableList[0].id)

          this.checkedTableList = []
        }, 30)
        // 复制新增
        this.pupopShow = true
        this.childrenType = '复制新增'
        this.djrqshow = true
        this.ckdisable = false
        this.bgdisable = false

        return
      }
    },
    // 多选框设置为单选功能
    handleSelectionChange(val) {
      this.checkedTableList = val
      if (val.length > 1) {
        this.$refs.cktable.clearSelection()
        this.$refs.cktable.toggleRowSelection(val.pop())
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 9) {
        switch (row.zt) {
          case '已出库':
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '变更审批中':
            cellStyle = 'color:#43A5E2;font-weight:bold '
            break
          case '草稿':
            cellStyle = 'color:#000;font-weight:bold '
            break
          default:
            cellStyle = ''
            break
        }
        return cellStyle
      }
    },
    // 内部分页方法
    pagesizeChange(val) {
      this.bgform.size = val
      this.htableDataall()
    },
    handleCurrentChange(val) {
      this.bgform.page = val
      this.htableDataall()
    }
  }
}
</script>
<style scoped lang='less'>
.el-table--border {
  z-index: 0;
}
.yk_report {
  // height: 100%;
  // width: 90%;
  // background-color: white;
  // margin: auto;
  .headerSearch {
    max-width: 1518px;
    width: 95%;
    margin: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }
    .chongzhiButton {
      width: 90px;
      height: 39px;
    }
  }
  .tablemes {
    margin: auto;
    width: 90%;
    max-width: 1375px;
    // margin-top: 21px;
    // margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    // .addButton {
    //   color: #fff;
    //   background: #4170ff;
    //   border-radius: 3px;
    //   border-color: #4170ff;
    // }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
    /deep/.el-table-column--selection .cell {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/.el-table__header-wrapper .el-checkbox {
  //找到表头那一行，然后把里面的复选框隐藏掉
  display: none;
}
</style>
